import { USER_DATA_KEY_HEADER_MOUNTBIT_AUTH } from "shared/constants/user"
import { v4 as uuidv4 } from 'uuid'

import { request } from "./request"


export const getChecksum = async (
  file: File
): Promise<string> => {
  const arrayBuffer = await file.arrayBuffer()

  // Вычисляем SHA-1 хеш
  const hashBuffer = await crypto.subtle.digest('SHA-1', arrayBuffer)

  // Преобразуем ArrayBuffer в base64url
  const byteArray = new Uint8Array(hashBuffer)
  const base64String = btoa(String.fromCharCode(...Array.from(byteArray)))

  // Преобразуем в URL-safe Base64
  const base64url = base64String
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '')

  return `sha1:${base64url}=`
}

const getEncodedUploadParams = (
  file: any,
  checksum: string,
): any => {
  const uploadParamsData = {
    file_params: {
      size: file.size,
      checksum,
    }
  }
  return `b64:${btoa(
    unescape(encodeURIComponent(JSON.stringify(uploadParamsData)))
  )}`
}

const generateRandomString = () => {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  for (let i = 0; i < 5; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return result
}


export const avatarApi = {
  getAvatars: async (userId: number) => {
    return request('GET', `/api/3/users/${userId}/avatars`, {
      preview: true,
      preview_jwt: true
    })
  },
  getAvatarResource: async (userId: number) => {
    return request('GET', `/api/3/users/${userId}/avatars/avatar`, {
      preview: true,
      preview_jwt: true
    })
  },
  deleteAvatar: async (userId: number, signal?: AbortSignal) => {
    return request('DELETE', `/api/3/users/${userId}/avatars/avatar/`, undefined, { signal })
  },
  uploadAvatarByUrl: async (uploadUrlTmpl: string, file: File, token: string, signal?: AbortSignal) => {
    const uploadId = uuidv4()
    const bk = generateRandomString()
    const avatarUploadUrl = uploadUrlTmpl.replace('{upload_id}', uploadId).replace('{bk}', bk)
    let checksum = ''
    try {
      checksum = await getChecksum(file)
    } catch (error) {
      console.error('Error getting checksum', error)
      throw error
    }
    const uploadParams = getEncodedUploadParams(file, checksum)
    const headers: Record<string, string> = {
      [USER_DATA_KEY_HEADER_MOUNTBIT_AUTH]: token,
      'Content-Type': file.type,
      'Upload-Params': uploadParams
    }

    const response = await fetch(avatarUploadUrl, {
      method: 'PUT',
      headers,
      body: file,
      signal
    })

    if (!response.ok) {
      throw new Error('Failed to upload avatar')
    }

    return response.json()
  }
}
